export default class MultiTrackAudioPlayer {
    tracks: MediaStreamTrack[] = [];
    audio: HTMLAudioElement;
    isPlaying = false;
  
    constructor() {
        this.audio = new Audio();
    }
  
    addTrack(track: MediaStreamTrack) {
        this.tracks.push(track);
        var that = this;
        setTimeout(function () {
          that.play();
        }, 150);
      }
    
      removeTrack(track: MediaStreamTrack) {
        this.tracks = this.tracks.filter(t => t !== track);
        this.play(); 
      }
  
    play() {
        const stream = new MediaStream(this.tracks);
        this.audio.srcObject = stream;
    
        this.audio.onplay = () => {
          this.isPlaying = true;
        }
    
        this.audio.onpause = () => {
          this.isPlaying = false;
        }
    
        this.audio.onended = () => {
          this.isPlaying = false;
        }
    
      // setTimeout(() => { 
        this.audio.play().catch(err => {
          // 处理错误
          console.error(`[MultiTrackPlayer] play err=${err}`);
        });
      // }, 500);
      }

      pause() {
        if (!this.isPlaying) return;
        
        this.audio.pause();
      }
    
      setVolume(volume: number) {
        if (volume < 0 || volume > 1) {
          console.error(`[MultiTrackPlayer] changeVolume: volume must be between 0 and 1`);
          return;
        }

        this.audio.volume = volume;
      }
}